import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { Construction, ArrowLeft, Clock } from 'lucide-react';

const ComingSoon = ({ title = "Coming Soon" }) => {
    const { theme } = useTheme();
    const isDarkMode = theme === 'dark';

    return (
        <div className={`min-h-screen flex items-center justify-center px-6 ${isDarkMode ? 'bg-slate-950' : 'bg-slate-50'}`}>
            <div className="text-center max-w-lg">
                <div className={`w-20 h-20 mx-auto mb-8 rounded-2xl ${isDarkMode ? 'bg-amber-500/10' : 'bg-amber-100'} flex items-center justify-center`}>
                    <Construction className="w-10 h-10 text-amber-500" />
                </div>
                
                <h1 className={`text-4xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-slate-900'}`}>
                    {title}
                </h1>
                
                <p className={`text-lg mb-8 ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                    We're working hard to bring you something amazing. This section is currently under maintenance.
                </p>
                
                <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full mb-8 ${isDarkMode ? 'bg-white/5 border border-white/10' : 'bg-white border border-slate-200'}`}>
                    <Clock className={`w-4 h-4 ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`} />
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>Check back soon</span>
                </div>
                
                <div>
                    <Link 
                        to="/" 
                        className="inline-flex items-center gap-2 px-6 py-3 bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold rounded-xl transition-colors"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ComingSoon;
